// 开发环境使用的cookie配置
// 直接粘贴完整的cookie字符串
export const rawCookie = `Cookie: ASP.NET_SessionId=hn0njtukb2gfvoansdqdngf2; imagesvr=https://imgsrc.gdtvdv.com; Hm_lvt_20331b59e8696816b0574c7e06e43b4b=1735303429; HMACCOUNT=32181B20D6E758EB; encryptedMemberInfo=U2FsdGVkX1+aeh72sTcBTibyNWbP8CJ+lMg0K4dy8qZw3bVpJvojE3+x24EJA9UOK5kZZvLEsdbGiWc2dJw5U+VWWymQ2Z9mkZSKNKRL6hT9eXM4jSoNzNAWCe1VMaCq; Hm_lpvt_20331b59e8696816b0574c7e06e43b4b=1735529272`

// 解析cookie字符串为对象
const parseCookie = (cookieStr) => {
  // 移除开头的 "Cookie: " 如果存在
  const cleanStr = cookieStr.replace(/^Cookie:\s*/, '')
  
  // 将cookie字符串分割为键值对对象
  return cleanStr.split(';').reduce((acc, pair) => {
    const [key, value] = pair.trim().split('=')
    if (key && value) {  // 确保key和value都存在
      acc[key.trim()] = value.trim()
    }
    return acc
  }, {})
}

// 判断是否为开发环境
export const isDev = process.env.NODE_ENV === 'development'

// 设置开发环境cookie
export const setDevCookie = () => {
  if (isDev) {
    // console.log('开始设置开发环境cookie');
    const cookieObj = parseCookie(rawCookie);
    // console.log('解析后的cookie对象:', cookieObj);
    
    Object.entries(cookieObj).forEach(([key, value]) => {
      const cookieString = `${key}=${value}; path=/; domain=${window.location.hostname}`;
      // console.log('设置cookie:', cookieString);
      document.cookie = cookieString;
    });
    
    // 验证cookie是否设置成功
    // console.log('设置后的所有cookies:', document.cookie);
  }
} 